import React from 'react'
import PropTypes from 'prop-types'

import { Card, ReadMore } from '../../../../../components'
import { THEMES } from '../../../../../utils'

/**
 * Contact Biography Component
 * @param props
 * @returns {*}
 * @constructor
 */
const Biography = ({ bio }) => {
  return (
    <Card
      title='Biography'
      theme={THEMES.DARK_SLATE}>
      <div className='card_section-detail--text'>
        {(bio && bio.length)
          ? <ReadMore
            lines={5}
            less='Read Less'
            more='Read More'
            text={bio.replace(/\\r|\\n/g, '<br>')}
            renderHTML
          />
          : 'No contact biography'}
      </div>
    </Card>
  )
}

Biography.propTypes = {
  bio: PropTypes.string
}

export default Biography
